import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { UpdateBrowserSectionContainer, UpdateBrowserSectionWrapper, } from "./subcomponents";
var UpdateBrowserSection = function () {
    var t = useTranslation().t;
    return (_jsx(UpdateBrowserSectionWrapper, { children: _jsxs(UpdateBrowserSectionContainer, { children: [_jsx("strong", { children: t("modal.updateBrowser.prefix") }), " ", t("modal.updateBrowser.text")] }) }));
};
export default UpdateBrowserSection;
